module.exports = __webpack_public_path__ + "static/media/Brienne of Tarth 1.71150b93.jpg";